module.exports = __webpack_public_path__ + "img/hking-logo-icon.537524bd.png";